import React from 'react';

export const BarChartSkeleton = ({ bars = 6 }) => {
  // Pre-defined heights to make the "data" look organic and varied
  const heights = ['h-32', 'h-48', 'h-24', 'h-56', 'h-40', 'h-36'];

  return (
    <div className="w-full rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      {/* Chart Title/Header Skeleton */}
      <div className="mb-8">
        <div className="h-5 w-48 animate-pulse rounded bg-gray-300"></div>
        <div className="mt-2 h-3 w-32 animate-pulse rounded bg-gray-200"></div>
      </div>

      {/* Main Chart Area */}
      <div className="flex items-end justify-between gap-2 border-b border-l border-gray-100 pb-2 pl-2">
        {Array.from({ length: bars }).map((_, i) => (
          <div key={i} className="flex flex-1 flex-col items-center gap-2">
            {/* The Bar */}
            <div
              className={`w-full max-w-[40px] animate-pulse rounded-t-md bg-gray-200 ${heights[i % heights.length]}`}
            ></div>
            {/* X-Axis Label Skeleton */}
            <div className="h-3 w-8 animate-pulse rounded bg-gray-100"></div>
          </div>
        ))}
      </div>

      {/* Legend Skeleton */}
      <div className="mt-6 flex justify-center gap-4">
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 animate-pulse rounded-full bg-gray-200"></div>
          <div className="h-3 w-16 animate-pulse rounded bg-gray-200"></div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 animate-pulse rounded-full bg-gray-200"></div>
          <div className="h-3 w-16 animate-pulse rounded bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
};

export default BarChartSkeleton;
